import { instance2 } from "App/constants";
import { capitalizeFirst, isNull } from "App/utils/helpers";
import React from "react";
import "./Wrapper.scss";

const getMenuByKeyword = async (keyword) => {
  try {
    const response = await instance2.get(
      `/menumanagement/search-menu?keyword=${keyword}`
    );

    if (response.data.status) {
      return {
        state: true,
        message: "",
        data: response.data.body,
      };
    } else {
      return {
        state: false,
        data: [],
        message: "",
      };
    }
  } catch (error) {
    return {
      state: false,
      data: [],
      message: "",
    };
  }
};

function WrapperSearchMenu({ handleClickMenu, setActiveSearch }) {
  const [filter, setFilter] = React.useState([]);
  const [menus, setMenus] = React.useState([]);
  const [activeIndex, setActiveIndex] = React.useState(0);

  const handleChange = (e) => {
    let val = e.target.value;

    setFilter(val);
    if (isNull(val)) {
      setMenus([]);
    } else {
      setNewMenu(val);
    }
  };

  const handleChangeKeyDown = (e) => {
    const old = parseInt(activeIndex);
    const elms = document.getElementsByClassName("search-menu-list-menu-item ");
    if (e.key === "ArrowDown") {
      if (old < elms.length - 1) {
        setActiveIndex(old + 1);
      }
    } else if (e.key === "ArrowUp") {
      if (old > 0) {
        setActiveIndex(old - 1);
      }
    }

    if (e.key === "Enter") {
      const code = document.querySelector(
        ".search-menu-list-menu-item.active span"
      );
      const name = document.querySelector(
        ".search-menu-list-menu-item.active p"
      );

      handleClickMenu({
        name: name.innerHTML,
        code: code.innerHTML,
      });
      setActiveSearch(false);
    }
  };

  const setNewMenu = async (keyword) => {
    const response = await getMenuByKeyword(keyword);
    if (response.state) {
      setMenus(response.data);
    } else {
      setMenus([]);
    }
  };

  const handleClickItem = (name, code) => {
    handleClickMenu({
      name,
      code,
    });
    setActiveSearch(false);
  };
  return (
    <div className='search-menu'>
      <div className='search-menu-content'>
        <div className='search-menu-input-container'>
          <div className='search-icon'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='h-5 w-5'
              viewBox='0 0 20 20'
              width={"20px"}
              fill='currentColor'>
              <path
                fillRule='evenodd'
                d='M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z'
                clipRule='evenodd'
              />
            </svg>
          </div>
          <input
            type='text'
            className='search-menu-input'
            placeholder='Search menu...'
            onChange={handleChange}
            autoFocus={true}
            onKeyDown={handleChangeKeyDown}
            value={filter}
          />

          <div className='esc'>esc</div>
        </div>

        <ul className='search-menu-list-menu-container custom-scrollbar'>
          {menus.map((menu, index) => {
            return (
              <li
                key={index}
                onClick={() => handleClickItem(menu.name, menu.code)}
                className={`search-menu-list-menu-item ${
                  index === activeIndex ? "active" : ""
                }`}
                style={{
                  borderRadius: `${
                    index + 1 === menus.length ? "0 0 8px 8px" : "0"
                  }`,
                }}>
                <p>{capitalizeFirst(menu.name)}</p>

                <span>{menu.code}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default WrapperSearchMenu;
